import axios from 'axios'
import { getToken, clearAuth } from './auth'

const service = axios.create({
  baseURL: '',
  timeout: 15000
})

service.interceptors.request.use((config) => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

service.interceptors.response.use(
  (resp) => {
    // 下载类请求（blob/arraybuffer）不走 ApiResult 解包
    const rt = resp && resp.config ? resp.config.responseType : ''
    if (rt === 'blob' || rt === 'arraybuffer') {
      return resp.data
    }

    const data = resp.data
    // 后端 ApiResult: { code, message, data }
    if (data && typeof data.code !== 'undefined' && data.code !== 0) {
      // 401：清理并回登录
      if (data.code === 401) {
        clearAuth()
        window.location.href = '#/login'
      }
      return Promise.reject(new Error(data.message || '请求失败'))
    }
    return data.data
  },
  (err) => Promise.reject(err)
)


export default service
